module.exports = __webpack_public_path__ + "img/rep-nicole.c3e8b36a.png";